import React, { useState, useEffect } from 'react'
import './index.less'
import { Popup } from '@xp-design/mobile'; // 手动按需加载 js
import { Toast } from 'antd-mobile'
import { trackGdp, trackGdpNoLogin } from '../../../../utils/gio-report';
import { getCarSeriesList } from '../../../measuring-tools/api';
import bigCircular from '@assets/big-circular.png';
import { goToPage, goToPageV2 } from '../../../../utils/common';
import SharePilePriceSelector from '../share-pile-price-selector';
import { getLatestOrder, queryCurrentUserBasicInfo, querySharePileInfo, shareOpenApply } from '../../../../api/pile-sharing';
import { floorData } from '../../../pile-sharing/pages/apply';
import SharingMessageModal from '../../../pile-sharing-manage/components/sharing-message-modal';
import { PILE_SHARING_FORM_KEY } from '../../../../utils/constants';
const HOME_PILE_OWNER_AGREEMENT = 'https://events.xiaopeng.com/0h3jvj.html?ch=00977&ps=event'


interface PropsRule {
    onChange: (val: boolean, data?: any) => void;
    open?: boolean;
    showBanner?: boolean;
    newPileShareInfo?: any;
    type?: 'installing-report' | 'pile-installation'
    orderNo: string;
}

interface PriceItemRule {
    sn: number;
    startTime: string;
    endTime: string;
    servicePrice: string;
}

interface ShareFormDataRule {
    orderNo: string;
    address: string;
    parkingSpaceNo: string;
    floor: string;
    longitude: 0,
    latitude: 0,
    name: string;
    billingPeriodList: PriceItemRule[];
    phoneNo: string;
    userNickName: string;
}

export const getTypeData = (pileShareInfo): any => {
    const opening = 'https://s.xiaopeng.com/xp-charge/charge/pile-apply/pileShareOpening.png'
    const opened = 'https://s.xiaopeng.com/xp-charge/charge/pile-apply/pileShareOpened.png'
    const waitForOpen = 'https://s.xiaopeng.com/xp-charge/charge/pile-apply/pileShareOpen.png'
    const isOpeningStatus = [1, 6]
    if (pileShareInfo?.hasStation) {
        // 已有站点
        return {
            type: 'opened',
            img: opened
        }
    }
    if (!pileShareInfo?.hasStation && pileShareInfo?.hasOpenApply) {
        // 无站点但有进行中的申请
        return isOpeningStatus.includes(pileShareInfo?.openApplyStatus)
            ?
            {
                type: 'opening',
                img: opening
            }
            :
            {
                type: 'waitForOpen',
                img: waitForOpen
            }
    }
    if (!pileShareInfo?.hasStation && !pileShareInfo?.hasOpenApply) {
        // 无站点且无进行中的申请
        return {
            type: 'waitForOpen',
            img: waitForOpen
        }
    }
}

const SharePileModal = (props: PropsRule) => {
    const { onChange, open, showBanner = true, newPileShareInfo, type = '', orderNo } = props
    const [visible, setVisible] = useState<boolean>(false)
    const [isCheck, setIsCheck] = useState(false)
    const [userInfo, setUserInfo] = useState<any>()
    const [pileShareInfo, setPileShareInfo] = useState<any>({})
    const [showPopupModel, setShowPopupModel] = useState<boolean>(false)
    const [dataNotComplete, setDataNotComplete] = useState<boolean>(false)
    const [pileShareFormData, setPileShareFormData] = useState<ShareFormDataRule>({
        orderNo: '',
        address: '',
        parkingSpaceNo: '',
        floor: '',
        longitude: 0,
        latitude: 0,
        name: '',
        billingPeriodList: [
            { sn: 0, startTime: '00:00', endTime: '24:00', servicePrice: '0.9' }
        ],
        phoneNo: '',
        userNickName: ''
    })
    const [currentTitle, setCurrentTitle] = useState<string>('一键开通共享家充')

    const changeCurrentTitle = (msg) => {
        console.log(msg, 'msg')
        setCurrentTitle(msg)
    }

    useEffect(() => {
        if (open !== undefined && open !== visible) {
            console.log(open, '确认成功，一键开通共享家充')
            changeCurrentTitle('确认成功，一键开通共享家充')
            setVisible(open)
        }
    }, [open])


    //获取用户登录信息
    const getUser = async (phoneNo?) => {
        const { data, code } = await queryCurrentUserBasicInfo()
        console.log('获取用户数据', data, code);

        if ([0, 200].includes(code)) {
            setUserInfo(data)
        }
    }

    useEffect(() => {
        if (newPileShareInfo) {
            querySharePileInfo().then(pileShareRes => {
                console.log(pileShareRes, 'pileShareRes')
                if ([0, 200].includes(pileShareRes.code)) {
                    setPileShareInfo(pileShareRes?.data || {})
                }
            })
        } else {
            setPileShareInfo(newPileShareInfo)
        }
        getUser()
    }, [])

    useEffect(() => {
        console.log(pileShareInfo, userInfo, '监听数据源变化触发初始化')

        pileShareInfo?.pileNo && userInfo && init()
    }, [pileShareInfo, userInfo])


    const init = async () => {
        let newData: any = {}
        // let autoOpenSharePileModal = localStorage.getItem(`${orderNo}_autoOpenSharePileModal`)
        // if (autoOpenSharePileModal !== '1') {
        // setVisible(true)
        //     localStorage.setItem(`${orderNo}_autoOpenSharePileModal`, '1')
        // }
        let res = await getLatestOrder({
            pileNo: pileShareInfo?.pileNo
        })
        console.log('基本', res)
        if ([0, 200].includes(res.code)) {
            console.log('从安装工单合并数据', {
                ...pileShareFormData,
                ...(res?.data?.data || {}),
                phoneNo: userInfo?.mobile,
                userNickName: userInfo?.nickName,
            })
            newData = {
                ...pileShareFormData,
                phoneNo: userInfo?.mobile,
                userNickName: userInfo?.nickName,
                parkingSpaceNo: res?.data?.data?.parkingSpaceNo,
                floor: res?.data?.data?.installFloor,
                billingPeriodList: [
                    { sn: 0, startTime: '00:00', endTime: '24:00', servicePrice: res?.data?.data?.defaultPrice }
                ],
            }
            // 地址信息一并处理 
            if (
                res?.data?.data?.cityCode && res?.data?.data?.city
                &&
                res?.data?.data?.provinceCode && res?.data?.data?.province
                &&
                res?.data?.data?.districtCode && res?.data?.data?.district
                &&
                res?.data?.data?.address
            ) {
                newData = {
                    ...newData,
                    cityCode: res?.data?.data?.cityCode,
                    provinceCode: res?.data?.data?.provinceCode,
                    districtCode: res?.data?.data?.districtCode,
                    city: res?.data?.data?.city,
                    province: res?.data?.data?.province,
                    district: res?.data?.data?.district,
                    address: res?.data?.data?.address,
                    name: res?.data?.data?.name,
                    longitude: res?.data?.data?.lon,
                    latitude: res?.data?.data?.lat
                }
            }
        }
        let applyData = JSON.parse(localStorage.getItem(PILE_SHARING_FORM_KEY) || '{}')
        console.log(applyData, '已填写过的私桩申请数据')
        applyData.parkingSpaceNo && (newData.parkingSpaceNo = applyData.parkingSpaceNo)
        applyData.floor && (newData.floor = applyData.floor)
        applyData.billingPeriodList && (newData.billingPeriodList = applyData.billingPeriodList)
        // 地址信息一并处理 
        if (
            applyData.cityCode && applyData.city
            &&
            applyData.provinceCode && applyData.province
            &&
            applyData.districtCode && applyData.district
            &&
            applyData.address
        ) {
            newData = {
                ...newData,
                cityCode: applyData.cityCode,
                provinceCode: applyData.provinceCode,
                districtCode: applyData.districtCode,
                city: applyData.city,
                province: applyData.province,
                district: applyData.district,
                address: applyData.address,
                name: applyData.name,
                longitude: applyData.longitude,
                latitude: applyData.latitude
            }
        }
        setPileShareFormData({
            ...newData
        })
    }


    // 打开协议
    const openProtocol = (e) => {
        e && e.stopPropagation()
        goToPageV2({ url: HOME_PILE_OWNER_AGREEMENT })
    }


    const protocolCheck = () => {
        setIsCheck(!isCheck)
    }


    const goToApply = () => {
        const { origin, pathname } = window.location
        goToPageV2({ url: `${origin}${pathname.replace('pile-apply.html', 'pile-sharing-manage.html')}#/` })
    }

    const confirm = async (check) => {
        console.log(pileShareFormData, dataNotComplete, '待提交表单信息')
        if (dataNotComplete) {
            goToApply()
            return
        }
        if (!check) {
            setShowPopupModel(true)
            return
        }
        const res = await shareOpenApply(
            {
                ...pileShareFormData,
                pileNo: pileShareInfo?.pileNo
            } as any
        )
        console.log(res, 'confirmRes')
        if ([0, 200].includes(res.code)) {
            Toast.show('提交成功')
            setTimeout(() => window.location.reload(), 1000)
        } else {
            Toast.show('提交失败')
        }
    }

    useEffect(() => {
        console.log(visible, 'visible')
        if (visible) {
            trackGdp('P20224', 'B004', {
                orderNo: orderNo,
                element_type: type
            })
            init()
        }
        onChange(visible, pileShareInfo)
    }, [visible])

    useEffect(() => {
        if ((pileShareInfo?.isPileMaterialVersionMatch && pileShareInfo?.hasPile) && showBanner) {
            trackGdp('P20224', 'B002', {
                orderNo: orderNo,
                state: getTypeData(pileShareInfo).type
            })
        }
    }, [pileShareInfo, showBanner])

    useEffect(() => {
        let newData: any = pileShareFormData
        // 检验回填数据是否完整
        if (
            !newData.cityCode || !newData.city
            ||
            !newData.provinceCode || !newData.province
            ||
            !newData.district || !newData.districtCode
            ||
            !newData.parkingSpaceNo
            ||
            !newData.address
        ) {
            setDataNotComplete(true)
        } else {
            setDataNotComplete(false)
        }
    }, [pileShareFormData])

    return <>
        {
            (pileShareInfo?.isPileMaterialVersionMatch && pileShareInfo?.hasPile) && showBanner
                ?
                <div
                    className='sharePileBanner'
                    onClick={
                        () => {
                            trackGdp('P20224', 'B003', {
                                orderNo: orderNo,
                                state: getTypeData(pileShareInfo).type
                            })
                            const isOpeningStatus = [1, 6]
                            if (getTypeData(pileShareInfo).type === 'waitForOpen') {
                                setVisible(true)
                            } else {
                                goToApply()
                            }
                        }
                    }
                >
                    <img src={bigCircular} alt="" className="bigCircular" />
                    <img className='pileShareBannerImg' src={getTypeData(pileShareInfo)?.img} alt="" />
                </div>
                :
                null
        }
        <Popup
            visible={visible}
            onMaskClick={() => {
                setVisible(false);
                changeCurrentTitle('一键开通共享家充');
            }}
            bodyStyle={{ maxHeight: '100vh' }}
        >
            <div className='pileShareFormWrap'>
                <img
                    className='closeIcon'
                    src={'https://s.xiaopeng.com/xp-charge/charge/charge-system/close_icon.svg'}
                    alt=''
                    onClick={() => {
                        console.log('弹窗关闭')
                        setVisible(false);
                        changeCurrentTitle('一键开通共享家充');
                    }}
                />
                <div className='pileShareFormTitle'>{currentTitle}</div>
                <div className='pileShareFormTip'>
                    开通共享家充，自主定价收益高
                </div>
                <div className='pileShareFormTip1'>
                    已有桩主月入2000元
                </div>
                <div className='pileShareFormContent'>
                    <div className='pileShareFormItem'>
                        <div className='formLabel'>站点名称</div>
                        <div className='formValue'>
                            <div className='formValueVal'>{pileShareFormData?.userNickName || '--'}的共享家充</div>
                        </div>
                    </div>

                    <div className='pileShareFormItemRow'>
                        <div className='formLabel'>详细地址</div>
                        {
                            pileShareFormData.address
                                ?
                                <div className='formTextEareValue'>
                                    {pileShareFormData.address}
                                </div>
                                :
                                <div className='formTextEareValueError'>
                                    获取失败，请在修改信息页补充
                                </div>
                        }
                    </div>

                    <div className='pileShareFormItem'>
                        <div className='formLabel'>车位楼层</div>
                        <div className='formValue'>
                            <div className='formValueVal'>{floorData.value?.find(i => i.value === pileShareFormData.floor)?.label}</div>
                        </div>
                    </div>

                    <div className='pileShareFormItem'>
                        <div className='formLabel'>车位号</div>
                        <div className='formValue'>
                            {
                                pileShareFormData.parkingSpaceNo
                                    ?
                                    <div className='formValueVal'>
                                        {pileShareFormData.parkingSpaceNo}
                                    </div>
                                    :
                                    <div className='formTextEareValueError'>
                                        获取失败，请在修改信息页补充
                                    </div>
                            }
                        </div>
                    </div>

                    <div className='pileShareFormItem'>
                        <div className='formLabel'>收费标准(建议)</div>
                        <div className='formValue'>
                            <SharePilePriceSelector
                                orderNo={orderNo}
                                onChange={(val) => {
                                    setPileShareFormData({
                                        ...pileShareFormData,
                                        billingPeriodList: [
                                            { sn: 0, startTime: '00:00', endTime: '24:00', servicePrice: val }
                                        ]
                                    })
                                }}
                                price={pileShareFormData?.billingPeriodList[0]?.servicePrice}
                                type={type}
                            />
                        </div>
                    </div>

                    <div className='pileShareFormItem'>
                        <div className='formLabel'>手机号(不可修改)</div>
                        <div className='formValue'>
                            <div className='formValueVal'>{pileShareFormData?.phoneNo || '--'}</div>
                        </div>
                    </div>
                </div>
                <div className='bottomPlaceHolder'></div>

                <div className='sharePileModalFooter'>
                    <div className='privacyBanner' onClick={protocolCheck}>
                        <img className='check-img' src={isCheck ? 'https://s.xiaopeng.com/xp-charge/charge/pile-apply/check-radio-black.png' : 'https://s.xiaopeng.com/xp-charge/charge/pile-apply/check-radio.svg'} alt="" />
                        <div className="protocol">我已阅读并同意 <span onClick={e => openProtocol(e)} className='read'>《小鹏家用充电桩共享协议》</span></div>
                    </div>

                    <div className='footerBtnGroup'>
                        <div
                            className='cancelBtn'
                            onClick={
                                () => {
                                    trackGdp('P20224', 'B006', {
                                        orderNo: orderNo,
                                        element_type: type
                                    })
                                    goToApply()
                                }}
                        >
                            修改信息
                        </div>
                        <div
                            className='confirmBtn'
                            onClick={
                                () => {
                                    trackGdp('P20224', 'B007', {
                                        orderNo: orderNo,
                                        element_type: type
                                    })
                                    confirm(isCheck)
                                }
                            }
                        >
                            确认开通
                        </div>
                    </div>
                </div>
            </div>
        </Popup >

        {/* 取消申请弹窗 */}
        <SharingMessageModal
            visible={showPopupModel}
            title='用户协议'
            text={
                <span className="protocol">
                    提交即同意<span onClick={openProtocol} className='read'>《小鹏家用充电桩共享协议》</span>
                </span>
            }
            cancelText="取消"
            onCancel={() => setShowPopupModel(false)}
            confirmText="同意并提交"
            onConfirm={() => {
                setIsCheck(true)
                setShowPopupModel(false)
                confirm(true)
            }}
        />
    </>
}

export default SharePileModal